import { useHistory } from 'react-router-dom';

import { PageLayout } from '@/components/templates/PageLayout';
import {
  CmBox,
  CmCard,
  CmErrorText,
  CmFlex,
  CmInput,
  CmLongLoading,
  CmText,
} from '@/components/uiParts';
import { redirect404Page } from '@/lib/AccessControl';
import { AccountTable } from '@/pages/camel-kiosk/accounts/index/components/AccountTable';
import { FilterOptions } from '@/pages/camel-kiosk/accounts/index/components/FilterOptions';
import { TablePagination } from '@/pages/camel-kiosk/accounts/index/components/TablePagination';
import { useCamelKioskAccountsPage } from '@/pages/camel-kiosk/accounts/index/useCamelKioskAccountsPage';
import { routes } from '@/router';
import { useManagerAccountMe } from '@/services/AuthEnterprise/hooks';

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <PageLayout title={routes.CamelKioskAccounts.title}>
    <CmCard mt="25px" height={`calc(100vh - 120px)`}>
      {children}
    </CmCard>
  </PageLayout>
);

const CamelKioskAccountsPage: React.FC = () => {
  // /* アクセス制御 */
  const history = useHistory();
  const { managerAccountMe } = useManagerAccountMe();
  redirect404Page('camel_kiosk_account_management', history, managerAccountMe);
  const {
    isLoading,
    error,
    currentPage,
    filterType,
    stores,
    handlers,
    searchTerm,
    setSearchTerm,
    borderColor,
    itemsPerPage,
    totalItems,
  } = useCamelKioskAccountsPage();

  if (error !== null) {
    return (
      <Layout>
        <CmErrorText>{error?.message}</CmErrorText>
      </Layout>
    );
  }

  return (
    <Layout>
      <CmBox
        p={6}
        bg="white"
        height="100%"
        display="flex"
        flexDirection="column"
      >
        <CmBox mb={6} flexShrink={0}>
          <CmText mb={2} fontSize="sm">
            店舗名
          </CmText>
          <CmInput
            placeholder="店舗名で検索"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            width="100%"
            maxW="600px"
          />
        </CmBox>
        <CmFlex
          mb={6}
          justifyContent="space-between"
          alignItems="center"
          flexShrink={0}
        >
          <FilterOptions
            filterType={filterType}
            onChange={handlers.handleFilterChange}
          />
          <TablePagination
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            totalItems={totalItems}
            onPageChange={handlers.handlePageChange}
          />
        </CmFlex>
        {isLoading ? (
          <CmLongLoading />
        ) : stores.length === 0 ? (
          <CmErrorText>店舗が登録されていません。</CmErrorText>
        ) : (
          <CmBox
            flex="1"
            overflow="auto"
            position="relative"
            borderWidth="1px"
            borderColor={borderColor}
            borderRadius="md"
          >
            <AccountTable
              stores={stores}
              onPasswordChange={handlers.handlePasswordChange}
              onConfigure={handlers.handleConfigure}
              onDelete={handlers.handleDelete}
              onCreateAccount={handlers.onCreateAccount}
            />
          </CmBox>
        )}
      </CmBox>
    </Layout>
  );
};

export default CamelKioskAccountsPage;
